if (!customElements.get("collection-moments")) {
  customElements.define("collection-moments", class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    init() {
      this.track = this.querySelector("[data-moments-track]");
      this.controls = this.querySelector("[data-moments-controls]");
      this.previous = this.querySelector(".m-slider-controls__button-prev");
      this.next = this.querySelector(".m-slider-controls__button-next");
      if (!this.track || !this.controls || !this.previous || !this.next) return;

      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.moments = Array.from(this.querySelectorAll("[data-moment-text]"), (text) => ({
        text,
        toggle: text.parentElement.querySelector("[data-moment-toggle]"),
      }));
      this.moments.forEach(({ text, toggle }) => {
        toggle.addEventListener("click", () => {
          const expanded = toggle.getAttribute("aria-expanded") !== "true";
          toggle.setAttribute("aria-expanded", String(expanded));
          toggle.textContent = expanded ? toggle.dataset.readLess : toggle.dataset.readMore;
          text.classList.toggle("m-moments__moment--clamped", !expanded);
          this.updateMoments();
        }, options);
      });
      [this.previous, this.next].forEach((button) => {
        button.type = "button";
        button.setAttribute("aria-controls", this.track.id);
      });
      this.previous.addEventListener("click", () => this.move(-1), options);
      this.next.addEventListener("click", () => this.move(1), options);
      this.track.addEventListener("scroll", () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(() => {
        this.updateMoments();
        this.update();
      });
      this.resizeObserver.observe(this.track);
      document.fonts.addEventListener("loadingdone", () => this.updateMoments(), options);
      this.updateMoments();
      this.update();
    }

    updateMoments() {
      this.moments.forEach(({ text, toggle }) => {
        const expanded = toggle.getAttribute("aria-expanded") === "true";
        text.classList.add("m-moments__moment--clamped");
        const overflowing = text.scrollHeight > text.clientHeight + 1;
        toggle.hidden = !overflowing && !expanded;
        text.classList.toggle("m-moments__moment--clamped", !expanded);
      });
    }

    update() {
      const slides = this.track.children;
      if (!slides.length) return;
      const overflowing = this.track.scrollWidth > this.track.clientWidth + 2;
      const viewport = this.track.getBoundingClientRect();
      const first = slides[0].getBoundingClientRect();
      const last = slides[slides.length - 1].getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === "rtl";
      this.controls.hidden = !overflowing;
      this.previous.disabled = !overflowing || (rtl ? first.right <= viewport.right + 5 : first.left >= viewport.left - 5);
      this.next.disabled = !overflowing || (rtl ? last.left >= viewport.left - 5 : last.right <= viewport.right + 5);
    }

    move(direction) {
      const first = this.track.firstElementChild;
      if (!first) return;
      const styles = getComputedStyle(this.track);
      const step = first.getBoundingClientRect().width + parseFloat(styles.columnGap || 0);
      this.track.scrollBy({
        left: step * direction * (styles.direction === "rtl" ? -1 : 1),
        behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
